export function queryStringToArray(source?: unknown, delimeter = ',') {
  return (typeof source === 'string' && source.split(delimeter)) || [];
}
